/**
 * The edge-facing API base URL shown in the `securelink-installer install`
 * command that the Connector and Shared-Gateway creation modals hand to an
 * operator.
 *
 * This was hard-coded to the shared orchestrator's hostname in both modals,
 * so a standalone environment (dev-N) printed an install command that pointed
 * a brand-new edge at a DIFFERENT cluster. Each environment serves its own
 * edge API under its own name (dev-1: `edge-api.dev-1.netlinkz.dev`), so the
 * value has to be per-deployment.
 *
 * Vite inlines `import.meta.env` at BUILD time, so this is a build argument,
 * not a runtime env var on the nginx container — see `Dockerfile.local`.
 * The default preserves the previous behaviour for every existing build.
 */
export const EDGE_API_URL: string =
  import.meta.env.VITE_EDGE_API_URL || 'https://edge-api.vsm.netlinkz.dev';
